import type { ReactNode } from 'react';

import styles from './Field.module.css';

interface FieldProps {
  label: ReactNode;
  htmlFor: string;
  className?: string;
  children: ReactNode;
}

// Обёртка "подпись + контрол": сохраняет связь <label htmlFor> ↔ id контрола
// (доступность и getByLabelText в тестах), задаёт вертикальный ритм формы.
export function Field({ label, htmlFor, className, children }: FieldProps): JSX.Element {
  const classes = [styles.field, className].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <label className={styles.label} htmlFor={htmlFor}>
        {label}
      </label>
      {children}
    </div>
  );
}
